module.exports = __webpack_public_path__ + "static/media/icons.e62e5a61.woff";